import { render, staticRenderFns } from "./IV01.vue?vue&type=template&id=a18bcd66"
import script from "./IV01.vue?vue&type=script&lang=js"
export * from "./IV01.vue?vue&type=script&lang=js"
import style0 from "./IV01.vue?vue&type=style&index=0&id=a18bcd66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports